import { InjectionToken, Type } from '@angular/core';

export interface LazyComponents {
    [key: string]: { loadComponent: () => Promise<Type<any>> };
}

export const lazyMapComponents: LazyComponents = {
    rpfavwidget: {
        loadComponent: () => import('./iframe-rp-fav-widget/iframe-rp-fav-widget.component').then((m) => m.IFrameRpFavWidgetComponent),
    },
    rpgyml: {
        loadComponent: () => import('./iframe-rp-gyml/iframe-rp-gyml.component').then((m) => m.IFrameRpGymlComponent),
    },
    subcategoryfooter: {
        loadComponent: () =>
            import('./iframe-subcategory-footer/iframe-subcategory-footer.component').then((m) => m.IframeSubCategoryAsFooterComponent),
    },
    nolazypathkey: {
        loadComponent: () => import('./lazy-route-error/lazy-route-error.component').then((m) => m.LazyRouteErrorComponent),
    },
    explorepage: {
        loadComponent: () => import('./explore-page/explore-page.component').then((m) => m.ExplorePageComponent),
    },
    CozyBingoWidgetComponent: {
        loadComponent: () => import('@casinocore/platform/cozy-bingo-widget').then((m) => m.CozyBingoWidgetComponent),
    },
    SlotRacesComponent: {
        loadComponent: () => import('@casinocore/platform/slot-races').then((m) => m.SlotRacesWrapperComponent),
    },

    SlotRacesPhase2Component: {
        loadComponent: () => import('@casinocore/platform/slot-races-phase2').then((m) => m.SlotRacesWrapperPhase2Component),
    },

    NewGameQuickInfoComponent: {
        loadComponent: () => import('@casinocore/platform/new-game-quick-info').then((m) => m.NewGameQuickInfoComponent),
    },
    SeoBoxSectionComponent: {
        loadComponent: () => import('./mod-casino/seo-box-section/seo-box-section.component').then((m) => m.SeoBoxSectionComponent),
    },
    RPFavSectionComponent: {
        loadComponent: () => import('./mod-casino/rp-fav-section/rp-fav-section.component').then((m) => m.RPFavSectionComponent),
    },
    RecentlyplayedGymlSectionComponent: {
        loadComponent: () =>
            import('./mod-casino/recentlyplayed-gyml-section/recentlyplayed-gyml-section.component').then(
                (m) => m.RecentlyplayedGymlSectionComponent,
            ),
    },
    ThumbnailHomeComponent: {
        loadComponent: () => import('./thumbnail-home/thumbnail-home.component').then((m) => m.ThumbnailHomeComponent),
    },
    NewsFeedSectionV2Component: {
        loadComponent: () => import('./mod-casino/news-feed-section-v2/news-feed-section-v2.component').then((m) => m.NewsFeedSectionV2Component),
    },
    PlayBingoBtnComponent: {
        loadComponent: () => import('@casinocore/platform/play-bingo-btn').then((m) => m.PlayBingoBtnComponent),
    },
    NewsFeedSectionComponent: {
        loadComponent: () => import('@casinocore/platform/news-feed-section').then((m) => m.NewsFeedSectionComponent),
    },
    StaticDiscoverFeedWrapperComponent: {
        loadComponent: () => import('@casinocore/platform/discover-feed').then((m) => m.StaticDiscoverFeedWrapperComponent),
    },
    GlobalJackpotSeoboxesComponent: {
        loadComponent: () => import('@casinocore/platform/global-jackpot-seoboxes').then((m) => m.GlobalJackpotSeoboxesComponent),
    },
    GlobalJackpotTandCComponent: {
        loadComponent: () => import('@casinocore/platform/global-jackpot-tnc').then((m) => m.GlobalJackpotTandCComponent),
    },
    GlobalJackpotWinnersFeedComponent: {
        loadComponent: () => import('@casinocore/platform/global-jackpot-winnersfeed').then((m) => m.GlobalJackpotWinnersFeedComponent),
    },
    LiveGamesSectionComponent: {
        loadComponent: () => import('@casinocore/platform/live-games-section').then((m) => m.LiveGamesSectionComponent),
    },
    GlobalJackpotContainerComponent: {
        loadComponent: () =>
            import('./mod-casino/global-jackpot-container/global-jackpot-container.component').then((m) => m.GlobalJackpotContainerComponent),
    },
    TeaserSectionComponent: {
        loadComponent: () => import('./mod-casino/teaser-section/teaser-section.component').then((m) => m.TeaserSectionComponent),
    },
    CasinoGameSelectorSectionComponent: {
        loadComponent: () =>
            import('./mod-casino/casino-game-selector-section/casino-game-selector-section.component').then(
                (m) => m.CasinoGameSelectorSectionComponent,
            ),
    },
    GameShowHubSectionComponent: {
        loadComponent: () => import('./mod-casino/game-show-hub-section/game-show-hub-section.component').then((m) => m.GameShowHubSectionComponent),
    },
    ChatIntegrationComponent: {
        loadComponent: () => import('./mod-casino/chat-integration/chat-integration.component').then((m) => m.ChatIntegrationComponent),
    },
    LiveCasinoLoungeSectionComponent: {
        loadComponent: () =>
            import('./mod-casino/live-casino-lounge-section/live-casino-lounge-section.component').then((m) => m.LiveCasinoLoungeSectionComponent),
    },
    ImmersiveLobbySectionComponent: {
        loadComponent: () =>
            import('./mod-casino/immersive-lobby-section/immersive-lobby-section.component').then((m) => m.ImmersiveLobbySectionComponent),
    },
    GamingStoriesSectionComponent: {
        loadComponent: () =>
            import('./mod-casino/gaming-stories-section/gaming-stories-section.component').then((m) => m.GamingStoriesSectionComponent),
    },
    SuperButtonSectionComponent: {
        loadComponent: () => import('./mod-casino/super-button-section/super-button-section.component').then((m) => m.SuperButtonSectionComponent),
    },
    PromotionsBannerSectionComponent: {
        loadComponent: () =>
            import('./mod-casino/promotions-banner-section/promotions-banner-section.component').then((m) => m.PromotionsBannerSectionComponent),
    },
    ArcadeTandCComponent: {
        loadComponent: () => import('./mod-casino/arcade-tnc/arcadeTandC.component').then((m) => m.ArcadeTandCComponent),
    },
    ArcadeRPSectionComponent: {
        loadComponent: () =>
            import('./mod-casino/arcade-recently-played-section/arcade-recently-played-section.component').then((m) => m.ArcadeRPSectionComponent),
    },
};

export const LAZY_COMPONENETS_MAPC = new InjectionToken('LAZY_COMPONENETS_MAPC', {
    factory: () => lazyMapComponents,
});
